export const ABOUT_US_STARTED = 'ABOUT_US_STARTED'
export const ABOUT_US_SUCCESS = 'ABOUT_US_SUCCESS'
export const ABOUT_US_FAILURE = 'ABOUT_US_FAILURE'

export const ABOUT_US_CHANGE = 'ABOUT_US_CHANGE'
